import { Stack } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";

const WebcallbackSubBlock = (props) => {
  const { isStepValidated = false, hasDate = false, children } = props;

  return (
    <Stack
      direction={{ xs: "column", lg: "row" }}
      spacing={isStepValidated ? 1 : 2}
      sx={{
        alignItems: isStepValidated ? { xs: "flex-start", lg: "center" } : { xs: "center", lg: "flex-end" },
        px: { xs: 2, lg: 5 },
        pt: 3,
        pb: hasDate ? 1 : { xs: 3, lg: 5 },
        border: "1px solid var(--border-default-blue-france)",
        borderTopWidth: 0,
        borderBottomWidth: hasDate ? 0 : "1px",
      }}
    >
      {children}
    </Stack>
  );
};

WebcallbackSubBlock.propTypes = {
  isStepValidated: PropTypes.bool,
  hasDate: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default WebcallbackSubBlock;
